/* global bz_app, Track */
bz_app.directive('photoRibbonRow', [
  function () {
    return {
      restrict: 'AE',
      scope: {
        context: '@',
      },
      link: function (scope, element) {
        element.click(function () {
          Track.send('Experiment', {
            action: 'photo ribbon header',
            context: scope.context,
          })
        })
      },
    }
  },
])
